import { createSlice } from '@reduxjs/toolkit';

const MachineReportDetailsDataSlice = createSlice({
    name: 'MachineReportDetailsData',
    initialState: '',
    reducers: {
        setMachineReportDetailsData: (state, action) => {            
            return action.payload;
        },
    },
});

export const { setMachineReportDetailsData } = MachineReportDetailsDataSlice.actions;
export default MachineReportDetailsDataSlice.reducer;